export const SECOND_FREE_TRIAL_FLOW_NAME = 'SecondFreeTrial';
